import React, { useContext, useState } from "react";
import classes from "./DeleteTask.module.scss";
import Modal from "../Modal/Modal";
import { ModalContext } from "../../store/modal-context";
import { BoardContext } from "../../store/board-context";

const DeleteTask = () => {
  const { modalPayload, closeModal } = useContext(ModalContext);
  const { boards, deleteTask } = useContext(BoardContext);
  const { boardId, columnId, taskId } = modalPayload;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const board = boards.find((b) => b.id === boardId);
  const column = board?.columns.find((col) => col.id === columnId);
  const task = column?.tasks.find((t) => t.id === taskId);

  if (!task) return null;

  const handleDelete = async () => {
    setIsSubmitting(true);
    await deleteTask(boardId, columnId, taskId);
    setIsSubmitting(false);
    closeModal();
  };

  return (
    <Modal>
      <section
        className={`${classes.delete_task}`}
      >
        <h3>delete this task?</h3>
        <p>
          Are you sure you want to delete the '{task.title}' task and its
          subtasks? This action cannot be reversed.
        </p>
        <section className={classes.delete_action}>
          <button className={classes.delete} onClick={handleDelete} disabled={isSubmitting}>
            {isSubmitting ? "deleting…" : "delete"}
          </button>
          <button
            className={`${classes.cancel}`}
            onClick={closeModal}
            disabled={isSubmitting}
          >
            cancel
          </button>
        </section>
      </section>
    </Modal>
  );
};

export default DeleteTask;
